export function debounce(fn, t, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timer;
    return function () {
        var arguments$1 = arguments;

        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments$1[_i];
        }
        var noTimer = !timer;
        if (timer)
            { clearTimeout(timer); }
        timer = setTimeout(function () {
            timer = null;
            if (!immediate && typeof (fn) === 'function')
                { fn.apply(_this, args); }
        }, t);
        if (immediate && noTimer && typeof (fn) === 'function') {
            fn.apply(this, args);
        }
    };
}
export function throttle(fn, t, immediate) {
    if (immediate === void 0) { immediate = false; }
    var lastArgs, timer;
    return function () {
        var arguments$1 = arguments;

        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments$1[_i];
        }
        var noTimer = !timer;
        var timeoutFn = function () {
            if (lastArgs) {
                if (typeof (fn) === 'function')
                    { fn.apply(_this, lastArgs); }
                lastArgs = null;
                timer = setTimeout(timeoutFn, t);
            }
            else {
                timer = null;
            }
        };
        if (!noTimer || !immediate) {
            lastArgs = args;
        }
        if (!timer)
            { timer = setTimeout(timeoutFn, t); }
        if (immediate && noTimer && typeof (fn) === 'function')
            { fn.apply(this, args); }
    };
}
//# sourceMappingURL=timers.js.map